// extracted by mini-css-extract-plugin
module.exports = {"container":"FormExpandField--styles-module_container-iZa27","label":"FormExpandField--styles-module_label-2GgPn","total":"FormExpandField--styles-module_total-2nzTu"};